<coin-v2-dialog-frame [header]="'cms.emails.select-index-item' | translate">
  <div class="body-container">
    <div class="selection-list">
      @for (item of selectionItems; track item) {
        <div
          class="selection-item"
          [class.selected]="selectedItem?.id === item.id"
          [class.active]="item.id | pure: isSelected : data.selectedItemReferenceIds"
          (click)="selectedItem = item">
          <div
            class="view-only"
            [innerHTML]="item.contentHtml"></div>
        </div>
      }
    </div>
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      type="secondary"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
    <coin-v2-button
      type="primary"
      [disabled]="!selectedItem"
      [text]="'general.proceed' | translate"
      (click)="proceed()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
